import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_LIST_FILTER: GlameraIconDefinition = {
  name: 'list-filter',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-list-filter-line glm-list-filter-line-1" d="M2 5h20"></path>
    <path class="glm-list-filter-line glm-list-filter-line-2" d="M6 12h12"></path>
    <path class="glm-list-filter-line glm-list-filter-line-3" d="M9 19h6"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-list-filter-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './list-filter.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ListFilterIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_LIST_FILTER;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
